<dialog #dialog role="dialog" aria-modal="true" (click)="onDialogClick($event)" (keydown)="onDialogKeydown($event)">
  <ng-content></ng-content>

  <button type="button" class="close-modal" (click)="closeCard()" aria-label="Fermer">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M4 4L16 16M4 16L16 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    </svg>
  </button>
</dialog>
